function capitalize(text) {
  return text.toString().charAt(0).toUpperCase() + text.toString().slice(1);
}

export default capitalize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/capitalize.js
// module id = null
// module chunks = 